export default function formatCurrency(value, locale = 'MYR') {
  const formatCurrency = Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return formatCurrency.format(value);
}
